"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChannelEventCallbacks = createChannelEventCallbacks;
var context_1 = require("../context");
function createChannelEventCallbacks(contextRef) {
    return {
        ai_experience_entered: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_experience_entered', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
        ai_experience_exited: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_experience_exited', __assign({}, (0, context_1.buildInChatContextProperties)(ctx)));
        },
    };
}
